import script from "./MedicationCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MedicationCard.vue?vue&type=script&setup=true&lang=js"

import "./MedicationCard.vue?vue&type=style&index=0&id=93303d3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93303d3a"]])

export default __exports__